// extracted by mini-css-extract-plugin
module.exports = {"saveTag":"winter-sale_saveTag__FEViB","text":"winter-sale_text__xa_lG"};